import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import "./content.css";

const SubscriptionTerms = () => {
  return (
    <div className="terms content_page">
      <div className="terms-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 pt-5">
              <div className="terms-info-wraps">
                {/* <Breadcrumb name={"Subscription Terms & Conditions"} pageName={"Subscription Terms & Conditions"} /> */}
                <div className="privacy-area">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="privacy-info-wraps">
                          <h4>Classhila - Subscription Terms &amp; Conditions</h4>
                          <h4>Table of Contents:</h4>
                          <ul>
                            <li>A. Subscription &amp; Eligibility</li>
                            <li>B. Compatible Devices</li>
                            <li>C. Educational Content</li>
                            <li>D. Additional Terms</li>
                          </ul>

                          <p>
                          Welcome to the terms of use for Classhila Subscription. These terms are between you and Classhila Education
Private Limited (&quot;Classhila,&quot; &quot;we,&quot; or &quot;us&quot;). Please carefully read these terms, along with the Privacy Policy,
Terms of Use, and all other rules and policies available or published on the Classhila platform or mobile
application (collectively referred to as the &quot;Agreement&quot;). The latest versions of these policies and terms can be
found on the Classhila website and/or mobile application for your reference and to understand how we handle
your personal information. By visiting, browsing, or using your Classhila Subscription, you are accepting this
Agreement.
                          </p>

                          <h4>A. Subscription &amp; Eligibility</h4>
                          <p>
                          Classhila Subscription (&quot;Subscription Service&quot;) is a personalized subscription that offers recommendations,
access to, and discovery of digital educational content. This content is created and live-streamed by top
educators (&quot;Educational Content&quot;) in your chosen category of interest. You can access the Subscription and
Educational Content through the Classhila website or Classhila mobile application by subscribing to any category
of your choice from the available subscription plans (&quot;Subscription&quot;). If you are under 18 years of age or have not
reached the age of majority in your location, you may use the Subscription only with the involvement of a parent
or guardian. We personalize content and feature them as part of the Subscription, including providing
recommendations on Educational Content in your subscribed category, as well as related categories that may be
of interest to you. We continuously strive to enhance the subscriptions and subscription plans to improve your
overall subscription experience.
                          </p>
                         <h4>B. Compatible Devices</h4>
                         <p>To access live-streamed courses/classes or download the Educational Content on the mobile application, you will
need to use a personal computer, portable media player, or other device that meets the system and compatibility
requirements (&quot;Compatible Device&quot;). The Compatible Devices may change over time, and whether a device
remains compatible may depend on software or systems provided or maintained by the device manufacturer or
other third parties. Therefore, please ensure that the device you use is compatible with our system/software to
avail of the Subscription Service.</p>
<h4>C. Educational Content</h4>
<p>Subscription allows you to access live-streaming of Educational Content in your subscribed category for a limited
period during the Subscription Period.</p>
<h4>Usage Rules</h4>
<p>Due to limitations imposed by our Educational Content providers (Educators), the Educational Content we make
available to you on Classhila Subscription is subject to viewing access restrictions and time limitations. These
restrictions may change over time as we introduce new features, devices, and content to our Subscription
Service. The following are the restrictions for accessing the Educational Content on Classhila Subscription:</p>
<h4>Downloading</h4>
<p>You can only download the Educational Content within the mobile application, and the downloaded content can
be viewed during the Subscription Period on your compatible devices. After downloading the Educational

Content, you will have access to it only during the Subscription Period. Access to the downloaded content will be
removed upon the expiry or termination of your Subscription, as applicable.</p>


<h4>Live Streaming of Educational Content</h4>
<p>You can attend live-streamed classes/courses of the Educational Content in your subscribed category during the
Subscription Period through your web browser or mobile application on compatible internet-connected devices.</p>
<h4>Viewing Period</h4>

<p>During your active subscription Period or as provided in this Agreement, you can attend live-streamed courses
and classes, as well as watch and re-watch recorded content by downloading or streaming within the
Subscription Period, as long as you have an active subscription.</p>

<h4>Subscription &amp; Payment</h4>
<p>You can subscribe to a category of your choice by selecting the Subscribe option and making the required
payment for your chosen subscription plan.</p>

<h4>Availability of Subscribed Educational Content</h4>

<p>Subscribers can generally access educational content through in-app downloads, streaming, or live
classes/courses throughout their subscription period. However, they may become unavailable due to potential
licensing restrictions imposed by Educators or other reasons. Classhila will not be liable if the Educational
Content in the subscribed category becomes unavailable for further in-app download or streaming. You may
download and store your own copy of Educational Content on a Compatible Device authorized for such in-app
download, but access to the in-app downloaded Educational Content will be removed upon the expiry of the
Subscription Period or in case of Educator licensing restrictions or termination of the Subscription as per this
Agreement.</p>
<h4>Limited License to Educational Content</h4>
<p>Upon full payment of the subscription fee and compliance with this Agreement, Classhila and the Educator grant
you a limited, non-transferable, and non-exclusive right to access, view, and attend live-streamed
classes/courses within the subscription period, as outlined in this Agreement. This license is for personal, non-
commercial, and private use only. After the end of the Subscription Period or in accordance with any specified
restrictions in this Agreement, we may automatically remove your access to the Educational Content from your
Compatible Device.</p>
<h4>Quality of Streaming</h4>
<p>The resolution and quality of the Educational Content you receive will depend on various factors, including the
type of Compatible Device you are using and your bandwidth, which may fluctuate during your viewing. While we
strive to provide a high-quality viewing experience, we cannot guarantee the resolution or quality of the streamed
Educational Content.</p>

<h4>In-App Downloading</h4>

<p>You are granted a license for in-app download of the Educational Content within the mobile application or on
other compatible devices as permitted. Unauthorized screen-casting or downloading on any other device or in
any manner not permitted herein will result in immediate termination of the Subscription, along with the
termination of access to all downloaded Educational Content. Classhila reserves the right to initiate appropriate
legal action, at its sole discretion.</p>
<h4>General Restrictions</h4>
<p>You may not: (i) copy, transfer, or display the Educational Content, except as permitted in this Agreement; (ii)
sell, rent, lease, distribute, or broadcast any rights to the Educational Content; (iii) remove any proprietary notices
or labels on the Educational Content; (iv) attempt to disable, modify, bypass, defeat, or otherwise circumvent any

digital rights management or content protection system used in the Subscription; or (v) use the Subscription or
Educational Content for any commercial or illegal purpose.</p>

<h4>D. Additional Terms</h4>

<h4>Communications</h4>
<p>We may communicate with you electronically, which may include promotions, emails, and push notifications. By
using the Subscription Service, you consent to receive such communications. These communications will be in
accordance with the Classhila Privacy Policy.</p>

<h4>Amendments</h4>
<p>Classhila reserves the right to make changes to this Agreement at any given point of time by posting the revised
terms in connection with the Subscription Service. By continuing to use the Subscription Service after any
changes, you accept the revised terms.</p>
<h4>Modification of Subscription</h4>
<p>Classhila reserves the right to modify, suspend, or discontinue the Subscription Service or any part of the
subscription service, thereof at any time and without notice (except as required by applicable law). Classhila will
not be liable to you for any impact on your ability to use Educational Content resulting from such changes.</p>
<h4>Disputes/Conditions of Use</h4>

<p>Any dispute related to this Agreement or the Subscription Service is subject to the governing law and will be
handled according to the terms outlined in the Classhila Terms of Use, including governing law, disclaimers of
warranties, liability limits, binding arbitration, and other terms specified. By using the Subscription Service, you
agree to these terms.</p>

<h4>Reservation of Rights or Waiver</h4>

<p>The Subscription Service and Educational Content are protected by intellectual property laws. Copyright owners
of the Educational Content (Educators) are intended third-party beneficiaries under this Agreement. If we don&#39;t
enforce this agreement strictly, it doesn&#39;t mean we&#39;ve given up our rights.</p>

<h4>Limitation of Liability</h4>
<p>Without limiting the disclaimer of warranties and limitation of liability in the Classhila Terms of Use: (i) our total
liability to you for all damages arising from or related to your use or inability to use the Subscription Service shall
not exceed INR 500 (Indian Rupees Five Hundred); and (ii) our or our Educational Content providers&#39; (Educators)
total liability to you for all damages arising from your use of the Subscription Service, the Educational Content, or
any information or materials made available through the Subscription Service shall not exceed INR 500 (Indian
Rupees Five Hundred). These limitations apply even if the remedies fail in their essential purpose.</p>

<h4>Severability</h4>
<p>If any term or condition of this Agreement is found to be invalid, void, or unenforceable for any reason, that part
will be considered severable and it will not affect the enforceability and validity of the remaining terms and
conditions.</p>

<h4>Contact Information</h4>


                          <p>
                            For communications regarding this Agreement, please contact Classhila at <a href="mailto:help.classhila@gmail.com">help.classhila@gmail.com</a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionTerms;
